import React from 'react';

import { JRCIcon } from 'components/JRCIcon/JRCIcon';

import { JRCAvatar } from 'components/JRCAvatar/JRCAvatar';
import { JRCButton } from 'components/JRCButton/JRCButton';
import { AvatarWrapper } from 'components/JRCCommentsBloc/JRCCommentsBloc';

import { JRCStyledHref } from 'components/JRCHref/JRCHref';

import { jFileLittle, jHref } from 'jamespot-user-api';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { JRCWidgetCheckListLink } from './JRCWidgetCheckListLink';
import { JRCWidgetCheckListImage } from './JRCWidgetCheckListImage';
import { htmlDecodeSpecialChars } from '../../../utils/utils.html';

export const CSSWidgetCheckListWrapper = styled.div``;

export const CSSWidgetCheckList = styled.ul`
    list-style: none;
`;

export const CSSWidgetCheckListItem = styled.li`
    :hover {
        background-color: ${(props) => props.theme.color.grey1};
        cursor: pointer;
    }

    border-bottom: 1px solid ${(props) => props.theme.color.grey1};

    :last-child {
        border-bottom: none;
    }
`;

export const CSSWidgetCheckListItemBtn = styled.button`
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 20px;
    align-items: center;
`;

export const CSSWidgetCheckListItemData = styled.div`
    margin-left: 20px;
    display: flex;
    flex-direction: column;
`;

export const CSSWidgetCheckListItemCheckBox = styled.div`
    display: flex;
    width: 40px;
`;

export const CSSWidgetCheckListItemLabel = styled.div`
    display: flex;
    flex: 1;
`;

export const CSSCheckboxWrapper = styled.button`
    border: 1px solid ${(props) => props.theme.color.grey2};
    background-color: ${(props) => props.theme.color.grey1};
    width: 24px;
    height: 24px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export type JRCWidgetCheckListEntryUser = {
    id: string | number;
    type: string;
    mainType: string;
};

export type JRCWidgetCheckListEntry = {
    text: string;
    checked: boolean;
    mimetype?: string;
    links?: jHref[];
    id?: number;
    file?: jFileLittle;
    user?: JRCWidgetCheckListEntryUser;
};

export type JRCWidgetCheckListEntries = JRCWidgetCheckListEntry[];

export type JRCWidgetCheckListProps = {
    initialEntries: JRCWidgetCheckListEntries;
    limit: number;
    inplace?: boolean;
    inplaceButtonLabel?: string;
    onFileClick: (entry: JRCWidgetCheckListEntry) => void;
    onNewItem?: () => void;
    onItemCheckListChange?: (index: number, items: JRCWidgetCheckListEntries) => void;
};

export const JRCWidgetCheckList = ({
    initialEntries,
    inplace,
    inplaceButtonLabel,
    limit,
    onFileClick,
    onNewItem,
    onItemCheckListChange,
}: JRCWidgetCheckListProps) => {
    const intl = useIntl();

    return (
        <CSSWidgetCheckListWrapper>
            <CSSWidgetCheckList>
                {Array.isArray(initialEntries) &&
                    initialEntries.map((entry, index) => {
                        return (
                            <CSSWidgetCheckListItem key={index}>
                                <CSSWidgetCheckListItemBtn
                                    onClick={() => {
                                        const newEntries = [
                                            ...initialEntries.map((entry, _) =>
                                                _ === index ? { ...entry, checked: !entry?.checked } : entry,
                                            ),
                                        ];

                                        if (onItemCheckListChange) {
                                            onItemCheckListChange(index, newEntries);
                                        }
                                    }}>
                                    <CSSWidgetCheckListItemCheckBox>
                                        <CSSCheckboxWrapper>
                                            {entry.checked && <JRCIcon name="icon-check" size={12} />}
                                        </CSSCheckboxWrapper>
                                    </CSSWidgetCheckListItemCheckBox>
                                    <CSSWidgetCheckListItemLabel>
                                        {entry.checked ? (
                                            <s style={{ opacity: 0.5 }}>{htmlDecodeSpecialChars(entry.text)}</s>
                                        ) : (
                                            htmlDecodeSpecialChars(entry.text)
                                        )}
                                    </CSSWidgetCheckListItemLabel>
                                    {entry.user && entry.checked && (
                                        <AvatarWrapper>
                                            <JRCStyledHref href={`/user/${entry.user.id}`}>
                                                <JRCAvatar uri={`user/${entry.user.id}`} size={3} variant="circle" />
                                            </JRCStyledHref>
                                        </AvatarWrapper>
                                    )}
                                </CSSWidgetCheckListItemBtn>
                                <CSSWidgetCheckListItemData>
                                    {entry.file !== undefined && (
                                        <JRCWidgetCheckListImage file={entry.file} onClick={() => onFileClick(entry)} />
                                    )}
                                    {entry.links &&
                                        entry.links.length > 0 &&
                                        entry.links.map((link, index) => (
                                            <JRCWidgetCheckListLink key={index} link={link} />
                                        ))}
                                </CSSWidgetCheckListItemData>
                            </CSSWidgetCheckListItem>
                        );
                    })}
            </CSSWidgetCheckList>
            {Array.isArray(initialEntries) && initialEntries.length < limit && inplace && (
                <JRCButton
                    label={inplaceButtonLabel ?? intl.formatMessage({ id: 'WIDGET_Check_List_Defaul_Label' })}
                    onClick={() => {
                        if (onNewItem) {
                            onNewItem();
                        }
                    }}
                />
            )}
        </CSSWidgetCheckListWrapper>
    );
};
